import { useContext } from "react";
import ModalPerfilContext from "../Context/ModalPerfilContext";
export function useModalPerfil() {
    const modalPerfilHelpers = useContext(ModalPerfilContext);
    return modalPerfilHelpers;
}